import { useEffect, useState } from 'react';
import { csv_utils_csv_to_array_of_objects } from '../utils/frfr-csv-utils';

const csv_validator = (csv) => {
  let valid = true;
  if (typeof csv === 'string') {
    if (csv === '') {
      valid = false;
    }
  } else {
    valid = false;
  }
  return valid;
};

export const useCsvEditorWidget = (initialState = '', separator = ',') => {

  const [csvInputVal, setCsvInputVal] = useState(initialState); // state for csv input value string
  const [csvSeparator, setCsvSeparator] = useState(separator); // state for csv input value string
  const [arrayOfObjectsFromCsv, setArrayOfObjectsFromCsv] = useState([]); //
  const [csvInputError, setCsvInputError] = useState(''); // state for csv validation error
  // const [csvColumnsError, setCsvColumnsError] = useState(false); // state for csv validation error

  const handleCsvInputChange = (e) => {
    const target = e.target;
    const value = target.value;
    // const name = target.name;
    if (csv_validator(value) === true) {
      setCsvInputError(''); // valid - no error
    } else {
      setCsvInputError('Invalid CSV'); // error
    }
    setCsvInputVal(value);
  };

  useEffect(() => {
    const array_of_objects_from_csv = csv_utils_csv_to_array_of_objects(csvInputVal, csvSeparator);
    setArrayOfObjectsFromCsv(array_of_objects_from_csv);
  }, [csvInputVal, csvSeparator]);

  //
  return {
    csvInputVal, handleCsvInputChange, csvInputError, setCsvInputVal, csvSeparator, setCsvSeparator, arrayOfObjectsFromCsv, csvEditorWidgetPack: {
      csvInputVal, handleCsvInputChange, csvInputError, setCsvInputVal, csvSeparator, setCsvSeparator, arrayOfObjectsFromCsv
    }
  };
};
